import { SubscribeToChannelsModal } from './SubscribeToChannelsModal';
import { SubscribeToMessageTypesModal } from './SubscribeToMessageTypesModal';
import { UnsubscribeFromMessageTypesModal } from './UnsubscribeFromMessageTypesModal';
import { UnsubscribeFromChannelsModal } from './UnsubscribeFromChannelsModal';

export const Modals = () => (
  <>
    <SubscribeToChannelsModal />
    <SubscribeToMessageTypesModal />
    <UnsubscribeFromChannelsModal />
    <UnsubscribeFromMessageTypesModal />
  </>
);
